import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { IProgressBarComponent, IIconComponent } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { BulkUploadProgressCounter } from "@m19-board/services/bulk-upload/bulk-upload-context.service";

@Component({
  selector: "app-bulk-upload-run-progress",
  templateUrl: "./bulk-upload-run-progress.component.html",
  imports: [TranslocoDirective, IProgressBarComponent, IIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BulkUploadRunProgressComponent {
  public readonly progress = input<BulkUploadProgressCounter | undefined>();

  public readonly completed = computed(() => this.progress()?.completed ?? 0);
  public readonly total = computed(() => this.progress()?.total ?? 0);
  public readonly ratio = computed(() => {
    const total = this.total();
    return total === 0 ? 0 : this.completed() / total;
  });
  public readonly hasFinished = computed(() => this.completed() === this.total());
}
